import { forwardRef, memo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { getRouteLocale } from "utils/helpers";

const LocaleLink = forwardRef(({ to, children, state = {}, ...restOfProps }, ref) => {
	const { i18n } = useTranslation();
	const { pathname } = useLocation();

	return (
		<Link
			to={`${getRouteLocale(i18n.language)}${to}`}
			state={{ from: pathname, ...state }}
			ref={ref}
			{...restOfProps}>
			{children}
		</Link>
	);
});

export default memo(LocaleLink);
